export default __webpack_public_path__ + "CircularPro-Black.b417614b.otf";